import {createAsyncThunk} from '@reduxjs/toolkit'
import {orderSummmaryApi} from './orderSummaryApi'

export const fetchCoupons = createAsyncThunk(
  'orderSummary/fetchCoupons',
  async ({client, country, coupon}, {rejectWithValue}) => {
    try {
      return await orderSummmaryApi.getCoupons(client, {country, coupon})
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)
